<template>
  <div class="text-center">
    <v-dialog :value="dialogSuccess" persistent transition="dialog-bottom-transition" width="450">
      <v-card class="pa-4 dialog-select">
        <v-card-title class="pa-0 justify-end">
          <v-icon large color="#152536" @click="closeDialog">mdi-close</v-icon>
        </v-card-title>
        <div class="text-center dialog-select">
          <v-img class="mb-4" src="@/assets/Success.png" height="140px" contain></v-img>
          <span class="sub-title-text">คุณได้ทำการบันทึกข้อมูลเรียบร้อยแล้ว</span>
        </div>

        <div class="pt-8 mx-sm-10 text-center dialog-select">
          <v-btn
            color="default_button_primary"
            :width="$vuetify.breakpoint.smAndUp ? '120' : ''"
            dark elevation="0"
            @click="closeDialog"
          >
            ตกลง
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "DialogSuccessComponent",
  props: {
    dialogSuccess: Boolean,
  },
  components: {
  },
  data() {
    return {

    };
  },
  computed: {
   
  },
  created() {
    
  },
  methods: {
    closeDialog() {
      this.$emit("clickedCloseDialog");
    },
  },
};
</script>
<style scoped>
.dialog-select {
  font-family: Noto Sans Thai !important;
}
.title-text {
  font-size: 20px;
  font-weight: 700;
  color: #333333;
}
.sub-title-text {
  font-size: 14px;
  font-weight: 400;
  color: #636363;
}
</style>